


import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Pagination,
  CircularProgress,
} from "@mui/material";
import MarkEmailReadOutlinedIcon from "@mui/icons-material/MarkEmailReadOutlined";
import CustomText, { textStyles } from "../../../components/CustomText";
import { useTranslation } from "react-i18next";
import { BASE_URL } from "../../../components/BaseUrl";
import { convertUTCToLocalDateTime } from "../../../components/dateTimeUtils";
import { decryptToken } from "../../../Utlis/Encryption";
import CustomButton from "../../../components/CustomButton";
import { toast } from "react-hot-toast"; 
import empty from "../../../assets/empty.png";
import back from "../../../assets/back.svg";
import {useNavigate,useLocation} from 'react-router-dom';
// Returns the notification's title/message in the current app language,
// falling back to the base (untranslated) field when no *_en/*_es value exists.
const getLocalizedField = (item, field, lang) => {
  if (!item) return "";
  const suffix = lang === "es" ? "es" : "en";
  return item[`${field}_${suffix}`] || item[field] || "";
};

const Notifications = () => {
  const { t, i18n } = useTranslation();
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false); // Button loading state
  const rawEncryptedToken = localStorage.getItem("token");
  const token = rawEncryptedToken ? decryptToken(rawEncryptedToken) : null;
  const [unreadCount, setUnreadCount] = useState(0);
  const limit = 5;
const navigate=useNavigate();
const location=useLocation();

  // // ------------------- Fetch Notifications -------------------
  // const fetchNotifications = async (pageNum = 1) => {
  //   setLoading(true);
  //   try {
  //     const offset = (pageNum - 1) * limit;
  //     const response = await fetch(
  //       `${BASE_URL}/notifications/worker?limit=${limit}&offset=${offset}`,
  //       {
  //         method: "GET",
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     if (!response.ok) throw new Error("Failed to fetch notifications");
  //     const data = await response.json();

  //     if (!data.error) {
  //       const { notifications, pagination } = data.data;
  //       setNotifications(notifications);
  //       setTotalPages(pagination.pages);
  //     } else {
  //       console.error("Error fetching notifications:", data.message);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching notifications:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const fetchNotifications = async (pageNum = 1) => {
  setLoading(true);
  try {
    // Backend paginates with `page` + `limit` (see data.pagination); `offset` is ignored → same items every page.
    const url = `${BASE_URL}/notifications/worker?limit=${limit}&page=${pageNum}`;
    console.log("[Notifications] GET", { page: pageNum, limit, url });

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to fetch notifications");

    const data = await response.json();
    console.log("[Notifications] response", data);

    if (!data.error) {
      const { notifications, pagination } = data.data;

      setNotifications(notifications ?? []);

      const total = pagination?.total;
      const pages =
        pagination?.pages ??
        (total != null && total > 0 ? Math.ceil(total / limit) : 1);
      setTotalPages(Math.max(1, pages));
      console.log("[Notifications] loaded", {
        itemsReturned: notifications?.length,
        total,
        totalPages: pages,
        pagination,
      });
    } else {
      console.warn("[Notifications] API error flag", data.message ?? data);
    }
  } catch (error) {
    console.error("Error fetching notifications:", error);
  } finally {
    setLoading(false);
  }
};


  // ------------------- Mark All As Read -------------------
  const markAllAsRead = async () => {
    setButtonLoading(true); // Start loading

    try {
      const response = await fetch(
        `${BASE_URL}/notifications/worker/mark-all-read`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();
      if (response.ok) {
        toast.success(t("notifications_marked_read")); // Show success toast
        fetchNotifications(page); // Re-fetch notifications
      } else {
        toast.error(data.message_en || data.message); // Show error toast
      }
    } catch (error) {
      console.error("Error marking all as read:", error);
      toast.error(t("error.markReadFailed")); // Show error toast in selected language
    } finally {
      setButtonLoading(false); // Stop loading
    }
  };

  useEffect(() => {
    fetchNotifications(page);
  }, [page]);


//   const handleNotificationClick = (notification) => {
//   if (notification.type === "request_approved") {
//     navigate("/request-management", {
//       state: { fromDashboard: true },
//     });
//   }
// };
const handleNotificationClick = (notification) => {
  switch (notification.type) {
    case "request_approved":
      navigate("/request-management", {
        state: { fromDashboard: true },
      });
      break;

    case "task_assigned":
      navigate("/task-management", {
       state: { fromDashboard: true },
      });
      break;

    case "task_completed":
      navigate("/task-management", {
     state: { fromDashboard: true },
      });
      break;

    case "check_in":
      navigate("/today-punch", {
      state: { fromDashboard: true },
      });
      break;

    case "check_out":
      navigate("/today-punch", {
       state: { fromDashboard: true },
      });
      break;

    case "payment_recorded":
      navigate("/expenses", {
        state: { fromDashboard: true },
      });
      break;

       case "expense_reimbursement_paid":
      navigate("/remuneration", {
        state: { fromDashboard: true },
      });
      break;

    case "system":
      navigate("/notifications", {
        state: { system: true },
      });
      break;

    default:
      console.warn("Unhandled notification type:", notification.type);
      navigate("/notifications");
  }
};

  const fromDashboard = location.state?.fromDashboard;

  // ------------------- UI -------------------
  return (
    <>
                      {fromDashboard && (
          <Box
            sx={{
              border: '1px solid #E4E6EF',
              borderRadius: 2,
              px: 2,
              backgroundColor: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              minHeight: 55,
              mb: 2,
              ml:1, mr:1
            }}
          >
            <Box
              sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
              onClick={() => navigate(-1)}
            >
              <img src={back} style={{ width: 30, height: 30 }} />
              <CustomText
                sx={{
                  ...textStyles.h1,
                  fontWeight: 500,
                  fontSize: '14px',
                  color: '#626F86',
                  textAlign: 'center'
                }}
              >
                {t('worker')} 
              </CustomText>
            </Box>
          </Box>
        )}
    <Box sx={{ px: 2, mt: 1 }}>

      <Box
        sx={{
          width: "100%",
          backgroundColor: "white",
          border: "2px solid #091E4224",
          borderRadius: 2,
          py: 2,
          minHeight: "70vh",
          position: "relative",
        }}
      >
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #E0E0E0",
            px: 2,
            pb: 2,
            mb: 2,
          }}
        >
          <CustomText
            sx={{
              ...textStyles.h1,
              fontWeight: 600,
              fontSize: "18px",
              color: "#003149",
            }}
          >
            {t("notification_screen.title") || "Notifications"}
          </CustomText>

          <IconButton
            onClick={markAllAsRead}
            sx={{
              backgroundColor: "#006EC2",
              color: "white",
              px: 2,
              borderRadius: "6px",
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
              "&:hover": { backgroundColor: "#005bb5" },
            }}
            disabled={buttonLoading} // Disable button while loading
          >
            {buttonLoading ? (
              <CircularProgress size={20} sx={{ color: "blue" }} />
            ) : (
              <>
                <MarkEmailReadOutlinedIcon fontSize="small" sx={{ mr: 0.5 }} />
                {t("mark_as_read")}
              </>
            )}
          </IconButton>
        </Box>

        {/* Loader */}
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "50vh",
            }}
          >
            <CircularProgress size={40} />
          </Box>
        ) : notifications.length === 0 ? (
          <Box
            sx={{
              flex: 1,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              py: 5,
            }}
          >
            <img src={empty} alt="No Data" style={{ width: 200, marginBottom: 16 }} />
            <CustomText
              sx={{
                ...textStyles.h1,
                fontWeight: 500,
                fontSize: "16px",
                color: "#003149",
              }}
            >
              {t("empty.no_user")}
            </CustomText>
          </Box>
        ) : (
          <>
            {/* Notification Table */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, px: 2 }}>
              {notifications.map((n) => (
                <Box
                onClick={() => handleNotificationClick(n)}
                  key={n.id}
                  sx={{
                    backgroundColor: !n.is_read ? "#EAF4FF" : "#fff",
                    border: !n.is_read ? "2px solid #006EC2" : "1px solid #DADADA",
                    borderRadius: 2,
                    px: 2,
                    py: 1.5,
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    gap: 2,
                    boxShadow: "0px 1px 2px rgba(0,0,0,0.05)",
                    cursor: "pointer",
                  }}
                >
                  <Box
                    sx={{
                      flex: "1 1 auto",
                      minWidth: 0,
                      overflowWrap: "anywhere",
                      wordBreak: "break-word",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        color: "#212121",
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {getLocalizedField(n, "title", i18n.language)}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "#555",
                        mt: 0.5,
                        fontFamily: "Poppins, sans-serif",
                      }}
                    >
                      {getLocalizedField(n, "message", i18n.language)}
                    </Typography>
                  </Box>

                  <Typography
                    sx={{
                      flex: "0 0 auto",
                      flexShrink: 0,
                      whiteSpace: "nowrap",
                      fontSize: 12,
                      color: "#5A6474",
                      fontFamily: "Poppins, sans-serif",
                      textAlign: "right",
                      pt: 0.25,
                    }}
                  >
                    {convertUTCToLocalDateTime(n.sent_at)}
                  </Typography>
                </Box>
              ))}
            </Box>

            {/* Pagination */}
            {totalPages > 1 && (
              <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
                <Pagination
                  count={totalPages}
                  page={page}
                  onChange={(e, val) => setPage(val)}
                  color="primary"
                />
              </Box>
            )}
          </>
        )}
      </Box>
    </Box>
    </>
  );
};

export default Notifications;

